// src/admin/components/OrdersList.js

import React from 'react';
import OrderGroupCard from './OrderGroupCard'; // OrderCard yerine bunu import et
import Alert from 'react-bootstrap/Alert';
import ListGroup from 'react-bootstrap/ListGroup';

// Prop adını 'orders' yerine 'orderGroups' olarak değiştirmek daha anlaşılır olur
function OrdersList({ orders: orderGroups, onRefresh, apiBaseUrl }) {
    if (!orderGroups || orderGroups.length === 0) {
        return (
            <Alert variant="info">
                <Alert.Heading>No Orders Found</Alert.Heading>
                <p>No orders matched your filter criteria.</p>
            </Alert>
        );
    }

    return (
        <ListGroup variant="flush">
            {orderGroups.map(group => (
                // key olarak grubun base ID'sini kullanıyoruz
                <ListGroup.Item key={group.baseOrderId} className="px-0 py-3">
                    <OrderGroupCard group={group} onRefresh={onRefresh} apiBaseUrl={apiBaseUrl} />
                </ListGroup.Item>
            ))}
        </ListGroup>
    );
}

export default OrdersList;